var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayVideo = function SvgPlayVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-664.000000, -18807.000000)",
    id: "Group-7",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.000000, 18729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CTA-Button---MD---Video",
    transform: "translate(0.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play-Icon---LG",
    transform: "translate(282.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.5,
    cy: 10.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85314986,7.89455434 L11.5304457,12.5718501 L12.2516628,7.17333725 L6.85314986,7.89455434 Z",
    id: "Rectangle",
    transform: "translate(9.187500, 10.237500) rotate(-315.000000) translate(-9.187500, -10.237500) "
  }))))))));
};
export { SvgPlayVideo as ReactComponent };
export default "data:image/svg+xml;base64,Cjxzdmcgdmlld0JveD0iMCAwIDIzIDIzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGcgaWQ9IlN0eWxlLUd1aWRlIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjY0LjAwMDAwMCwgLTE4ODA3LjAwMDAwMCkiIGlkPSJHcm91cC03IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzODMuMDAwMDAwLCAxODcyOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJDVEEtQnV0dG9uLS0tTUQtLS1WaWRlbyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDYzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJQbGF5LUljb24tLS1MRyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjgyLjAwMDAwMCwgMTYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGN4PSIxMC41IiBjeT0iMTAuNSIgcj0iMTAuNSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02Ljg1MzE0OTg2LDcuODk0NTU0MzQgTDExLjUzMDQ0NTcsMTIuNTcxODUwMSBMMTIuMjUxNjYyOCw3LjE3MzMzNzI1IEw2Ljg1MzE0OTg2LDcuODk0NTU0MzQgWiIgaWQ9IlJlY3RhbmdsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS4xODc1MDAsIDEwLjIzNzUwMCkgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTkuMTg3NTAwLCAtMTAuMjM3NTAwKSAiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";